import { render, staticRenderFns } from "./SpaceTypePicker.vue?vue&type=template&id=a8e85d50&"
import script from "./SpaceTypePicker.vue?vue&type=script&lang=js&"
export * from "./SpaceTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports